import { render, staticRenderFns } from "./privacyAgreementDetail.vue?vue&type=template&id=82f517c2"
import script from "./privacyAgreementDetail.vue?vue&type=script&lang=js"
export * from "./privacyAgreementDetail.vue?vue&type=script&lang=js"
import style0 from "./privacyAgreementDetail.vue?vue&type=style&index=0&id=82f517c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports